import { render, staticRenderFns } from "./DisplayInfosEvenementModal.vue?vue&type=template&id=1bd4ceb7"
import script from "./DisplayInfosEvenementModal.vue?vue&type=script&lang=js"
export * from "./DisplayInfosEvenementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports